import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import axios from "axios";
import SubmitButton from "common/components/Button/SubmitButton";
import CustomBreadcrumb from "common/components/CustomBreadcrumb";
import LoadingSpinner from "common/components/LoadingSpinner";
import VersionForm from "common/containers/Forms/Version/VersionForm";
import { useAuth } from "common/hooks/useAuth";
import { useProject } from "common/hooks/useProject";
import { BACKEND_URL_CONFIG } from "config";
import { ERRORS } from "errors";
import MainLayout from "layouts/MainLayout";
import { Fragment, useEffect, useId, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "./NewVersionPage.module.css";

export default function NewVersionPage() {
  // Contexts
  const { currentUser } = useAuth();
  const { projectId } = useParams();
  const navigate = useNavigate();

  // Hooks
  const { projectInfo } = useProject();

  // States
  const [loading, setLoading] = useState(false);
  const [allUsersInformation, setAllUsersInformation] = useState({});
  const [formData, setFormData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Form states
  const formId = useId();

  useEffect(() => {
    fetchUsersInformation();
  }, []);

  useEffect(() => {
    if (formData) {
      const payload = {
        name: formData.name,
        user_id: currentUser.uid,
        owner_ids: formData.owner_ids,
        authorized_user_ids: formData.authorized_user_ids,
      };
      saveVersion(payload);
    }
  }, [formData]);

  const fetchUsersInformation = async () => {
    try {
      setLoading(true);
      const response = await axios.get(BACKEND_URL_CONFIG.getAllUserNames, {
        headers: {
          "X-KEY": currentUser.accessToken,
        },
      });
      if (response.status === 200) {
        setAllUsersInformation(response.data);
      }
    } catch (error) {
      toast.error(ERRORS.error_133);
    } finally {
      setLoading(false);
    }
  };

  const saveVersion = async (payload) => {
    try {
      setLoading(true);
      const url = `${BACKEND_URL_CONFIG.createVersion}?project_id=${projectId}`;
      const response = await axios.post(url, payload, {
        headers: {
          "X-KEY": currentUser.accessToken,
        },
      });
      if (response?.status === 201) {
        toast.success("Votre nouvelle version a été créée.");
        navigate(`/projects/${projectId}`);
      }
    } catch (error) {
      if (error.response.status === 403) {
        toast.error(ERRORS.error_129);
      } else {
        toast.error(ERRORS.error_136);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <MainLayout>
        <div className={styles.container}>
          <div className={styles["breadcrumbs-wrapper"]}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
              <CustomBreadcrumb
                component="a"
                href="/"
                label="Page d'accueil"
                icon={<FontAwesomeIcon icon={faHome} />}
              />
              <CustomBreadcrumb
                component="a"
                href="/projects"
                label="Projets"
              />
              <CustomBreadcrumb
                component="a"
                href={`/projects/${projectId}`}
                label={projectInfo?.name}
              />
              <CustomBreadcrumb label="Nouvelle version" href="#" />
            </Breadcrumbs>
          </div>
          <div className={styles["form-container"]}>
            <div className={styles["title-wrapper"]}>
              <div className={styles.title}>Créer une nouvelle version</div>
            </div>
            <div className={styles["form-wrapper"]}>
              <div className={styles["content"]}>
                {loading ? (
                  <LoadingSpinner />
                ) : (
                  <VersionForm
                    formId={formId}
                    setFormData={setFormData}
                    allUsersInformation={allUsersInformation}
                    setIsSubmitting={setIsSubmitting}
                  />
                )}
              </div>
            </div>
            <div className={styles["stepper-action-buttons-wrapper"]}>
              <SubmitButton
                disabled={isSubmitting}
                style={{ backgroundColor: "#142637cc", color: "white" }}
                formId={formId}
                value="Enregistrer"
              />
            </div>
          </div>
        </div>
      </MainLayout>
    </Fragment>
  );
}
